import { createFileRoute, redirect } from "@tanstack/react-router";
import { readLocalApi } from "../localApi";
import { AdministrationSettings } from "../components/settings/AdministrationSettings";
export const Route = createFileRoute("/settings/admin")({
  beforeLoad: async () => {
    const connect = readLocalApi()?.connect;
    let admin = false;
    try {
      const status = await connect?.getStatus();
      admin = status?.state === "signed-in" && (await connect?.cloudAllowance?.())?.admin === true;
    } catch {
      admin = false;
    }
    if (!admin) throw redirect({ to: "/settings/account", replace: true });
  },
  component: AdministrationSettings,
});
